import { connect, Component, Currency } from 'macguffin'
import {
  setWinCountUpComplete,
  winCountUpStep,
  winCountUpLevel
} from 'game/redux/actions'
import ArrayHelper from 'utils/ArrayHelper'
import BackgroundImage from 'utils/BackgroundImage'
import CountUpPanel from './CountUpPanel'

import { Loader } from "pixi.js"
import { Tween } from '@tweenjs/tween.js'
import { Stage } from 'mc_pixi-fiber'

const { resources } = Loader.shared
const { max } = Math

export const WIN_LEVELS = [
  { multiplier: 1, levelString: '', level: 0 },
  { multiplier: 16, levelString: 'win.big', level: 1 },
  { multiplier: 32, levelString: 'win.super', level: 2 },
  { multiplier: 64, levelString: 'win.mega', level: 3 },
  { multiplier: 128, levelString: 'win.epic', level: 4 }
]

const COUNT_UP_LEVEL_DURATION = 1000
const COUNT_UP_STEPS = 50
const COUNT_UP_INTERVAL = COUNT_UP_LEVEL_DURATION / COUNT_UP_STEPS

const WIN_DISPLAY_DURATION = 1000

const WIN_COUNT_SCALE = 0.75
const WIN_COUNT_FONT_SCALE = 0.1
const WIN_LEVEL_FONT_SCALE = 0.15

const STEP_SOUND_INTERVAL = 5

function getSteps(start, end, winLevel) {
  const stepSize = (end - start) / COUNT_UP_STEPS
  const steps = []

  let step = start
  for (let i = 0; i < COUNT_UP_STEPS - 1; i++) {
    step += stepSize
    steps.push({
      step,
      ...winLevel
    })
  }

  steps.push({
    step: end,
    ...winLevel
  })

  return steps
}

function generateCountUp(bet, winAmount) {
  let maxWinLevel = WIN_LEVELS[0]
  let countUp = [{ step: 0, ...maxWinLevel }]

  let current = 0
  let previous = 0

  for (let i = 0, l = WIN_LEVELS.length; i < l; i++) {
    const winLevel = WIN_LEVELS[i]
    const amount = bet * winLevel.multiplier

    if (winAmount > amount) {
      current = amount
      const steps = getSteps(previous, current, winLevel)
      countUp = countUp.concat(steps)
      previous = current
      maxWinLevel = winLevel
    }
  }

  if (winAmount > current) {
    const steps = getSteps(current, winAmount, maxWinLevel)
    countUp = countUp.concat(steps)
  }

  return countUp
}

@connect(
  state => ({
    currentWinCountUp: state.game.currentWinCountUp,
    bet: state.base.response && state.base.response.ba,
    respinSummary: state.game.respinSummary,
    freespinSummary: state.game.freespinSummary,
    skipfeature: state.base.skipfeature,
    globalPaused: state.base.paused
  }),
  {
    setWinCountUpComplete,
    winCountUpStep,
    winCountUpLevel
  }
)
export default class WinCounter extends Component {
  constructor(props) {
    super(props)

    const prepare =
      resources['win-feedback_atlas_page_winfeedback.png'].texture.baseTexture

    this.state = { prepare }
  }
  componentWillReceiveProps(nextProps) {
    const currentProps = this.props
    const {
      currentGameMode,
      currentWinCountUp,
      respinSummary,
      freespinSummary
    } = nextProps

    if (nextProps.currentWinCountUp === currentProps.currentWinCountUp) {
      return
    }

    if (currentWinCountUp && currentWinCountUp > 0) {
      if (respinSummary || freespinSummary) {
        const countUp = generateCountUp(
          nextProps.bet,
          nextProps.currentWinCountUp
        )
        this.setState({ countUp, countUpIndex: 0 }, this.countUp)
      } else {
        this.setState({ win: currentWinCountUp })
      }
    } else {
      this.setState({
        countUp: undefined,
        countUpIndex: undefined,
        win: undefined
      })
    }

    if (
      nextProps.skipfeature &&
      nextProps.skipfeature !== currentProps.skipfeature
    ) {
      const { countUp } = this.state

      if (countUp) {
        if (this.timeout) {
          this.timeout.stop()
          this.timeout = undefined
        }

        this.setState({ countUpIndex: ArrayHelper(countUp).lastIndex() })
      }
    }
  }

  countUp = () => {
    const { props, state } = this
    const { bet } = props
    const { countUp, countUpIndex = 0, win = 0 } = state

    if (ArrayHelper(countUp).isLastIndex(countUpIndex)) {
      this.props.winCountUpLevel(countUp[countUpIndex].level)
      return
    }

    if (!(countUpIndex % STEP_SOUND_INTERVAL)) {
      this.props.winCountUpStep(countUpIndex)
    }

    this.timeout = new Tween()
      .to({}, COUNT_UP_INTERVAL)
      .onComplete(() => {
        if (
          countUpIndex &&
          countUp[countUpIndex].level !== countUp[countUpIndex - 1].level
        ) {
          this.props.winCountUpLevel(countUp[countUpIndex].level)
        }
        this.setState({ countUpIndex: countUpIndex + 1 }, this.countUp)
      })
      .start()
  }

  renderWin = (width, height) => {
    const { props, state } = this
    const { bet } = props
    const { win } = state

    const winFormat = {
      showCurrency: true,
      useSeparators: true,
      showSubUnits: false
    }

    const size = `${height * WIN_COUNT_SCALE}px`

    const winCounterStyle = {
      height: size,
      width: size,
      fontSize: `${height * WIN_COUNT_FONT_SCALE}px`,
      backgroundPosition: 'center'
    }

    let counterLevel = 0
    WIN_LEVELS.forEach(winLevel => {
      if (win > bet * winLevel.multiplier) {
        counterLevel = max(0, winLevel.level - 1)
      }
    })

    return (
      <BackgroundImage
        key="winCounter"
        className="winCounter"
        assetName="winFeedback"
        style={winCounterStyle}
      >
        <div className={`winCounterAmount level${counterLevel}`}>
          {' '}
          {Currency.format(win, winFormat)}{' '}
        </div>
      </BackgroundImage>
    )
  }

  renderCountUp = (width, height) => {
    const { state } = this
    const { countUp, countUpIndex } = state
    const currentLevel = countUp[countUpIndex]

    const countUpFormat = {
      showCurrency: true,
      useSeparators: true,
      showSubUnits: true
    }

    const winLevelStyle = {
      fontSize: `${height * WIN_LEVEL_FONT_SCALE}px`
    }

    const size = `${height * WIN_COUNT_SCALE}px`

    const winCounterStyle = {
      height: size,
      width: size,
      fontSize: `${height * WIN_COUNT_FONT_SCALE}px`,
      backgroundPosition: 'center'
    }

    const counterLevel = max(0, currentLevel.level - 1)

    return [
      <div key="winLevel" className="winLevel" style={winLevelStyle}>
        {this.t(currentLevel.levelString)}
      </div>,
      <BackgroundImage
        key="winCounter"
        className="winCounter"
        assetName="winFeedback"
        style={winCounterStyle}
      >
        <div className={`winCounterAmount level${counterLevel}`}>
          {' '}
          {Currency.format(currentLevel.step, countUpFormat)}{' '}
        </div>
      </BackgroundImage>
    ]
  }

  render() {
    const { props, state, renderWin, renderCountUp } = this
    const {
      left,
      top,
      width,
      height,
      resolution,
      visibility,
      globalPaused
    } = props
    const { countUp, countUpIndex, win, prepare } = state

    const containerStyle = {
      left: `${left}px`,
      top: `${top}px`,
      width: `${width}px`,
      height: `${height}px`,
      visibility
    }

    let renderFunction

    if (win) {
      renderFunction = renderWin
    } else if (countUp) {
      renderFunction = renderCountUp
    }

    return (
      <div className="winCounterContainer" style={containerStyle}>
        <Stage
          key="winCanvas"
          name="winCanvas"
          style={{ width, height }}
          {...{
            resolution: resolution,
            width: width,
            height: height,
            paused: globalPaused || !countUp,
            options: {
              prepare,
              transparent: true,
              backgroundColor: 0x000000,
              antialias: true,
            }
          }}
        >
          {countUp && (
            <CountUpPanel
              width={width}
              height={height}
              level={countUp[countUpIndex].level}
            />
          )}
        </Stage>
        {renderFunction && renderFunction(width, height)}
      </div>
    )
  }

  componentDidUpdate(prevProps, prevState) {
    const { props, state } = this
    const { setWinCountUpComplete } = props
    const { countUp, countUpIndex, win } = state

    const countUpChanged =
      countUpIndex !== prevState.countUpIndex &&
      ArrayHelper(countUp).isLastIndex(countUpIndex)
    const winChanged = win && win !== prevState.win

    if (winChanged || countUpChanged) {
      const delay = new Tween()
        .to({}, WIN_DISPLAY_DURATION)
        .onComplete(setWinCountUpComplete)
        .start()
    }
  }
}
